if (!customElements.get("header-nav")) {
  class HeaderNav extends HTMLElement {
    constructor() {
      super();

      this.CSSRoot = document.querySelector(":root");
    }

    get height() {
      return parseInt(this.offsetHeight);
    }

    set CSSRootHeight(height) {
      this.CSSRoot.style.setProperty("--nav-height", height + "px");
    }

    /* The mobile search bar is a separate sticky bar under the nav; anything stacking under both needs its height. 0 on desktop. */
    publishSearchbarHeight() {
      const bar = document.querySelector(".header-pseudo-searchbar--mobile");

      this.CSSRoot.style.setProperty(
        "--searchbar-height",
        (bar ? bar.offsetHeight : 0) + "px"
      );
    }

    connectedCallback() {
      this.CSSRootHeight = this.height;
      this.publishSearchbarHeight();

      window.addEventListener("resize", () => {
        this.CSSRootHeight = this.height;
        this.publishSearchbarHeight();
      });

      this.addEventListener(
        "nav-height-change",
        () => (this.CSSRootHeight = this.height)
      );

      // Catches box changes nothing announces: late fonts, the announcement bar closing, rotation.
      if (typeof ResizeObserver !== "undefined") {
        const observer = new ResizeObserver(() => {
          this.CSSRootHeight = this.height;
          this.publishSearchbarHeight();
        });

        observer.observe(this);

        const bar = document.querySelector(".header-pseudo-searchbar--mobile");
        if (bar) {
          observer.observe(bar);
        }
      }
    }
  }
  customElements.define("header-nav", HeaderNav);
}

(function () {
  let prevTopDistance = window.scrollY;
  let prevDir = "";
  var headerNav = document.querySelector("header-nav");

  /* Where a bar is pinned under the search bar, the search bar stays hidden until near the top, or the pinned bar jumps on every direction change. */
  var pinsUnderSearchbar = !!document.querySelector(
    ".collection-toolbar-sticky, .sticky-article-toc, .pdp-section-nav"
  );

  function dispatchNavChange() {
    headerNav.dispatchEvent(new CustomEvent("nav-height-change"));
  }

  if (window.innerWidth < 1440) {
    window.addEventListener(
      "scroll",
      function () {
        if (window.scrollY > prevTopDistance && prevDir !== "down" && window.scrollY > 200) {
          prevDir = "down";
          headerNav.classList.add("hide--searchbar");
          document.body.classList.add("hide--searchbar");
        } else if (
          window.scrollY < prevTopDistance &&
          prevDir !== "up" &&
          (!pinsUnderSearchbar || window.scrollY <= 200)
        ) {
          prevDir = "up";
          document.body.classList.remove("hide--searchbar");
          headerNav.classList.remove("hide--searchbar");
        }

        if (window.scrollY > 200) {
            headerNav.classList.add('sticked-nav');
        } else {
            headerNav.classList.remove('sticked-nav');
        }

       // dispatchNavChange();

        prevTopDistance = window.scrollY <= 0 ? 0 : window.scrollY;
      },
      false
    );
  }
})();
